import { Spinner } from "react-bootstrap";

const Fetching = ({ topMargin, bottomMargin, marginInline, newStyles, variant, message }) => {
	const other_styles = newStyles ? newStyles : null;

	return (
		<div
			style={{
				textAlign: "center",
				marginTop: topMargin ? topMargin : "15em",
				marginBottom: bottomMargin ? bottomMargin : "0em",
				marginInline: marginInline ? marginInline : "initial",
				...other_styles,
			}}
		>
			<Spinner animation="grow" variant={variant ? variant : "success"} />
			{message && <div style={{ marginTop: "1em", color: "#555", fontSize: "14px" }}>{message}</div>}
		</div>
	);
};

export default Fetching;
